import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./index.scss"

export default function ExtendedReportColumnBlock({ component }) {
  const { blockBackground, columns } = component

  return (
    <div className={`columns-block ${blockBackground}`}>
      <div className="container">
        <div className="row">
          {columns.map((column, index) => (
            <div
              className={`col-lg-${index === 0 ? "5" : "6"} col-md-6 ${
                index === 1 && "offset-lg-1 "
              }${column.columnText === "" && " standalone-image"}`}
            >
              <div className={`column ${column.columnBgColor}`}>
                {column.columnImage && (
                  <GatsbyImage
                    image={getImage(column.columnImage)}
                    className="column--image"
                  />
                )}
                {column.columnText && (
                  <div
                    className="column--text"
                    dangerouslySetInnerHTML={{ __html: column.columnText }}
                  />
                )}
                {column.ctaButton?.length > 0 && (
                  column.ctaButton.map(button =>
                    <div class="button-wrapper">
                      <a
                        href={button.linkUrl}
                        className="btn btn-primary"
                      >
                        {button.label}
                      </a>
                    </div>
                  )
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
